'use strict';
import Vue from 'vue';
import forEach from 'lodash/forEach';


function getSaveableChart(chart, index){
	const self = this;
	let sachart = {};

	sachart.id = chart.id;

	sachart.position = chart.position;
	sachart.trashed  = chart.trashed;
	sachart.visible  = chart.visible;
	sachart.template = chart.template;
	if(chart.newImage){
		sachart.image = chart.image;
	}

	if(chart.charts){
		sachart.charts = {};
		Object.keys(chart.charts).forEach(function(key, index){
			sachart.charts[chart.charts[key].id] = getSaveableChart(chart.charts[key], index);
		});
	}

	sachart.fields = {};
	forEach(chart.fields, (field, key) => {
		if(key == 'background-image' || key == 'background-video') return;
		if(field.changed){
			sachart.fields[key] = field.value;
		}
	});

	return sachart;
};

export default {
	SET_PRESENTATION({dispatch, rootGetters,getters, commit}, data) {
		if(rootGetters.devmode) console.debug('A|SET_PRESENTATION');

		if(data) commit('SET_PRESENTATION', data);
        if(data.id) commit('SET_PRESENTATIONID', data.id);
		if(data.charts) {
			commit('SET_CHARTS', data.charts);
		} else {
			console.log(data.charts, data);
			commit('UNSET_CHARTS');
		}

		if(data.addablecharts) {
			commit('SET_ADDABLECHARTS', data.addablecharts);
		} else {
			commit('UNSET_ADDABLECHARTS');
		}
	},

	SAVE_PRESENTATION({dispatch, rootGetters, getters, commit}, presentation) {
		if(rootGetters.devmode) console.debug('A|SAVE_PRESENTATION');

		let preUrl, id;
		let payload = {};

		if(presentation.type == 'user') {
			preUrl 		= getters.channel.urls.user,
			id 			= presentation.id;
		} else {
			preUrl 		= getters.channel.urls.presentation,
			id 			= (presentation.type == 'master' ? 'master' : presentation.id);
		}

		payload.id = id;
		payload.charts = {};
		forEach(presentation.charts, (chart, index) => {
			payload.charts[chart.id] = getSaveableChart(chart, index);
		});

		const url = preUrl.replace(':id:', id);
		console.log(url, payload, 'presentation');
		// this.restpatch(url, payload, 'presentation')
		// .then(message => {
		// 	if(message && message.updated && message.updated.charts) {
		// 		self.updateCharts(message.updated.charts);
		// 	} else {
		// 		self.updateCharts(message);
		// 	}
		// });
	},

	ADD_CHART({state, dispatch, rootGetters, getters, commit}, payload){
		if(rootGetters.devmode) console.debug('A|ADD_CHART', payload);

		if(Array.isArray(state.charts)) {
			console.warn('chart.charts is array');
			state.charts = {};
		}

		let parent = state.charts;
		if(typeof getters.addchart == 'number' && getters.addchart != 0) {
			let chart = getters.getChartById(getters.addchart);
			if(chart) {
				if(Array.isArray(chart.charts)) {
					console.warn('chart.charts is array');
					chart.charts = {};
				}

				parent = chart.charts;
			}
		} else if(typeof getters.addchart == 'object') {
			if(getters.addchart.parent) {
				let chart = getters.getChartById(getters.addchart.parent);
				if(chart) {
					if(Array.isArray(chart.charts)) {
						console.warn('chart.charts is array');
						chart.charts = {};
					}
					parent = chart.charts;
				}
			}

			payload = Object.assign({}, payload, getters.addchart);
		}

		if(parent !== state.charts) delete payload.charts; // darf halt nur auf der root ebene sein
		if(!payload.position) payload.position = Object.keys(parent).length; // update position

		if(rootGetters.devmode) console.debug('M|ADD_CHART on ', payload.position, ' to parent:', parent);

		Vue.set(parent, payload.id.toString(), payload);

		if(rootGetters.devmode) console.debug('M|ADD_CHART CHART', parent);

		return parent[payload.id.toString()];
	},

	// WIP
	UPDATE_FIELD({state, dispatch, rootGetters, getters, commit}, payload){
		if(rootGetters.devmode) console.debug('A|UPDATE_FIELD', payload);
		const id = payload.id,
			  fieldname = payload.fieldname;

		dispatch('socket/SEND_PACKAGE', {
			name: 'UPDATE_FIELD',
			payload: payload,
			time: new Date().getTime()
		});

		let chart = getters.getChartById(id),
			field = chart.fields[fieldname];

		Object.keys(payload).forEach(key => {
			if(key == 'id' || key == 'fieldname') return;

			Vue.set(field, key, payload[key]);

			Vue.set(field, 'changed', true);
		});

		chart.changed = true;

		state.charts = state.charts; // trigger update?

		return field;
	},
};



// WEBPACK FOOTER //
// ./src/store/preseditor/actions.js